import { apiRequest, primeCsrf } from "@/api/client";
import { endpoints } from "@/api/endpoints";
import type { AuthenticatedUser } from "@/types/domain";

export const authService = {
  me: () => apiRequest<AuthenticatedUser>(endpoints.auth.me),
  async login(email: string, password: string, remember = false) {
    await primeCsrf();
    return apiRequest<AuthenticatedUser>(endpoints.auth.login, {
      method: "POST",
      body: { email, password, remember },
    });
  },
  async logout() {
    return apiRequest<{ ok: true }>(endpoints.auth.logout, { method: "POST" });
  },
  forgotPassword: (email: string) =>
    apiRequest<{ ok: true }>(endpoints.auth.forgotPassword, {
      method: "POST",
      body: { email },
    }),
  resetPassword: (token: string, email: string, password: string, passwordConfirmation: string) =>
    apiRequest<{ ok: true }>(endpoints.auth.resetPassword, {
      method: "POST",
      body: { token, email, password, password_confirmation: passwordConfirmation },
    }),
  verifyEmail: (token: string) =>
    apiRequest<{ ok: true }>(endpoints.auth.verifyEmail, {
      method: "POST",
      body: { token },
    }),
  resendVerification: () =>
    apiRequest<{ ok: true }>(endpoints.auth.resendVerification, {
      method: "POST",
    }),
};
